"use client";

import * as z from "zod";
import { useForm } from "react-hook-form";
import React, { useEffect, useState, useTransition } from "react";
import { zodResolver } from "@hookform/resolvers/zod";

import { ResetSchema } from "@/schemas";
import { reset } from "@/actions/auth/reset";
import StyledInput from "@/components/common/input/styled-input";
import TransparentButton from "@/components/common/transparent-button";
import styles from "./reset-password-form.module.scss";
import ErrorText from "@/components/pages/auth/components/error-text";
import SuccessText from "@/components/pages/auth/components/success-text";

export const ResetForm = () => {
  const [error, setError] = useState<string | undefined>("");
  const [success, setSuccess] = useState<string>("");
  const [isPending, startTransition] = useTransition();

  const form = useForm<z.infer<typeof ResetSchema>>({
    resolver: zodResolver(ResetSchema),
    defaultValues: { email: "" },
    mode: "onChange", // Додаємо режим валідації при зміні
  });

  const emailValue = form.watch("email");
  useEffect(() => {
    setError(undefined);
  }, [emailValue]);

  const onSubmit = (values: z.infer<typeof ResetSchema>) => {
    setError("");
    setSuccess("");

    startTransition(() => {
      reset(values).then((data) => {
        setError(data?.error);
        setSuccess(data?.success ?? "");
      });
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.forgot_text}>Forgot your password?</div>
      <div className={styles.column_container}>
        <div className={styles.input_container}>
          <StyledInput
            title="Enter your email"
            type="email"
            placeholder="Email"
            isDisabled={isPending}
            isValid={!form.formState.errors.email}
            registerField={form.register("email")}
            error={form.formState.errors.email?.message}
          />
          {form.formState.errors.email && (
            <ErrorText error={form.formState.errors.email.message} />
          )}
        </div>
        <div className={styles.button_with_info}>
          <TransparentButton
            disabled={
              isPending || !form.formState.isValid || success.length > 0
            }
            onClick={form.handleSubmit(onSubmit)}
          >
            Send reset email
          </TransparentButton>
          {error && <ErrorText error={error} />}
          {success && <SuccessText success={success} />}
        </div>
      </div>
    </div>
  );
};
